import { render, staticRenderFns } from "./CCGN.vue?vue&type=template&id=dfe4a770&scoped=true"
import script from "./CCGN.vue?vue&type=script&lang=js"
export * from "./CCGN.vue?vue&type=script&lang=js"
import style0 from "./CCGN.vue?vue&type=style&index=0&id=dfe4a770&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe4a770",
  null
  
)

export default component.exports